import { getContext } from '@/context';
import getTotalCredits from '@/utils/monetization/creditsUtils';

import type { CreditInfo, CreditsResponse } from '@/types';

/**
 * Current user's credit balance (subscription + addon credits, summed).
 * Goes through the SDK monetization subsystem.
 */
const getUserCredits = async (): Promise<number> => {
  const fresh = (await getContext().monetization.updateCredits()) as unknown as
    | CreditInfo
    | undefined;
  const freshTotal = getTotalCredits({ creditsInfo: fresh });
  if (freshTotal !== null) return freshTotal;

  const state =
    (await getContext().monetization.credits.getState()) as CreditsResponse;
  return getTotalCredits(state) ?? 0;
};

export default getUserCredits;
